import type { ElementType } from "react";
import DashboardIcon from "@rsuite/icons/Dashboard";
import DetailIcon from "@rsuite/icons/Detail";
import PageIcon from "@rsuite/icons/Page";
import FolderIcon from "@rsuite/icons/Folder";
import GridIcon from "@rsuite/icons/Grid";
import TagIcon from "@rsuite/icons/Tag";
import ListIcon from "@rsuite/icons/List";
import SettingIcon from "@rsuite/icons/Setting";
import PeoplesIcon from "@rsuite/icons/Peoples";
import MemberIcon from "@rsuite/icons/Member";
import ImageIcon from "@rsuite/icons/Image";
import MediaIcon from "@rsuite/icons/Media";
import MenuLineIcon from "@rsuite/icons/Menu";
import StarIcon from "@rsuite/icons/Star";
import TaskIcon from "@rsuite/icons/Task";
import MessageIcon from "@rsuite/icons/Message";
import CreditCardPlusIcon from "@rsuite/icons/CreditCardPlus";
import IdInfoIcon from "@rsuite/icons/IdInfo";
import PhoneIcon from "@rsuite/icons/Phone";
import ShareRoundIcon from "@rsuite/icons/ShareRound";
import DocPassIcon from "@rsuite/icons/DocPass";
import ReviewIcon from "@rsuite/icons/Review";
import CouponIcon from "@rsuite/icons/Coupon";
import PieChartIcon from "@rsuite/icons/PieChart";
import TextImageIcon from "@rsuite/icons/TextImage";
import TreemapIcon from "@rsuite/icons/Treemap";

export type NavIcon = ElementType;

export type MenuSubItem = {
  name: string;
  url: string;
  Icon: NavIcon;
};

export type MenuItem = {
  name: string;
  url: string;
  Icon: NavIcon;
  show: boolean;
  color: string;
  sub: MenuSubItem[];
};

export const DashboardMenu: MenuItem[] = [
  {
    name: "Dashboard",
    url: "/dashboard",
    Icon: DashboardIcon,
    show: false,
    color: "blue",
    sub: [],
  },
  {
    name: "Blogs",
    url: "/dashboard/Blog",
    Icon: DetailIcon,
    show: true,
    color: "#CCD5AE",
    sub: [
      {
        name: "Article List",
        url: "/dashboard/Blog/Articles",
        Icon: TextImageIcon,
      },
      {
        name: "Blog Group",
        url: "/dashboard/Blog/list",
        Icon: FolderIcon,
      },
    ],
  },
  {
    name: "Products",
    url: "/dashboard/Products",
    Icon: GridIcon,
    show: true,
    color: "#CCD5EE",
    sub: [
      {
        name: "Products List",
        url: "/dashboard/Products/Products",
        Icon: ListIcon,
      },
      {
        name: "Products Group",
        url: "/dashboard/Products/ProductsGroup",
        Icon: FolderIcon,
      },
      {
        name: "Brand",
        url: "/dashboard/Products/Brands",
        Icon: TagIcon,
      },
      {
        name: "Price Group",
        url: "/dashboard/PriceGroup",
        Icon: PieChartIcon,
      },
    ],
  },
  {
    name: "shop setting",
    url: "/dashboard/shop",
    Icon: CouponIcon,
    show: true,
    color: "#CCD5EE",
    sub: [
      {
        name: "تنظیمات ارسال",
        url: "/dashboard/shop/post",
        Icon: TreemapIcon,
      },
      {
        name: "راه های پرداخت",
        url: "/dashboard/shop/payments",
        Icon: CreditCardPlusIcon,
      },
      {
        name: "نظرات",
        url: "/dashboard/shop/comments",
        Icon: MessageIcon,
      },
    ],
  },
  {
    name: "Forms",
    url: "/dashboard/Forms",
    Icon: TaskIcon,
    show: true,
    color: "#CCD5EE",
    sub: [
      {
        name: "Froms",
        url: "/dashboard/Forms/list",
        Icon: ListIcon,
      },
      {
        name: "Form Builder",
        url: "/dashboard/Forms/formlist",
        Icon: DocPassIcon,
      },
      {
        name: "درخواست همکاری",
        url: "/dashboard/Cooperation/list",
        Icon: ReviewIcon,
      },
      {
        name: "مشاوره محصولات",
        url: "/dashboard/Consultation/list",
        Icon: PhoneIcon,
      },
    ],
  },
  {
    name: "Setting",
    url: "/dashboard/Setting",
    Icon: SettingIcon,
    show: true,
    color: "#E0E5B6",
    sub: [
      {
        name: "General",
        url: "/dashboard/Setting/general",
        Icon: SettingIcon,
      },
      {
        name: "Social Network",
        url: "/dashboard/Setting/socialnetwork",
        Icon: ShareRoundIcon,
      },
      {
        name: "Contact",
        url: "/dashboard/Setting/contact",
        Icon: IdInfoIcon,
      },
    ],
  },
  {
    name: "کاربران وفروش",
    url: "/dashboard/User",
    Icon: PeoplesIcon,
    show: true,
    color: "#E8B86D",
    sub: [
      {
        name: "User List",
        url: "/dashboard/User/list",
        Icon: MemberIcon,
      },
      {
        name: "لیست فاکتورها",
        url: "/dashboard/User/invoices",
        Icon: PageIcon,
      },
    ],
  },
  {
    name: "Feature",
    url: "/dashboard/Feature",
    Icon: StarIcon,
    show: true,
    color: "#E8B86D",
    sub: [
      {
        name: "Menus",
        url: "/dashboard/Feature/Menus",
        Icon: MenuLineIcon,
      },
      {
        name: "Story",
        url: "/dashboard/Feature/Story",
        Icon: MediaIcon,
      },
    ],
  },
  {
    name: "Gallery",
    url: "/dashboard/Gallery",
    Icon: ImageIcon,
    show: true,
    color: "#FAEDCE",
    sub: [
      {
        name: "Sliders",
        url: "/dashboard/Gallery/list",
        Icon: MediaIcon,
      },
      {
        name: "Gallery",
        url: "/dashboard/Gallery/gallery",
        Icon: ImageIcon,
      },
    ],
  },
];
